import { TransactionContainer } from "views/containers/transactions";

export const TransactionPage = () => {
  return <TransactionContainer />;
};
